import { useLingui } from '@lingui/react'
import * as React from 'react'

// ! keep in sync with `@lingui/core` library
export type LinguiMessageDescriptor = {
  id: string
  comment?: string
  message?: string
  values?: Record<string, unknown>
}

/**
 * Returns the translation function from the `@lingui/react` library.
 * Consumes the `I18nProvider` from the `@lingui/react` library via the `useLingui` hook.
 * Use it to translate the text in the components.
 *
 * @example
 *
 * import { useTrans } from '~logic/i18n/useTrans'
 * import { msg } from '@lingui/macro'
 *
 * const Component = () => {
 *  const { trans } = useTrans()
 *  return <Text>{trans(msg`Hello, World!`)}</Text>
 * }
 */
export const useTrans = () => {
  const { _ } = useLingui()

  return React.useMemo(() => ({ trans: _ }), [_])
}
